import { PaperClipOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { MainContainer } from "@/shared/layout/Layout";
import { PrimaryText } from "@/shared/ui/Typography";

export const StyledAPContainer = styled(MainContainer)`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledAPHeader = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;
`;

export const StyledAPImageWrapper = styled.div`
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    position: relative;

    .ant-image {
        width: 100%;
        height: 100%;
    }

    img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
        border-radius: 4px;
    }
`;

export const StyledBadgeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 4px;
    position: absolute;
    z-index: 10;
    top: -8px;
    right: -8px;
`;

export const StyledBadge = styled.div<{ $background: "error" | "warning" }>`
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 20px;
    height: 20px;
    background-color: ${({ theme, $background }) =>
        $background === "error"
            ? theme.dangerTypographyColor
            : theme.colors.warning};
    color: ${({ theme }) => theme.colors.white};
`;

export const StyledAPTable = styled.div`
    border-radius: 6px;
    width: 100%;
    padding: 16px 12px;

    background: ${(props) => props.theme.secondaryBackgroundColor};

    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledAPTableRow = styled.div`
    padding-bottom: 12px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};

    display: grid;
    grid-template-columns: 155px 1fr;
    gap: 12px;
    align-items: center;

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPTableLink = styled(Link)`
    font-size: 14px;
    font-weight: 500;
    line-height: 120%;
    color: ${(props) => props.theme.secondaryTypographyColor};
    text-decoration: underline;
    text-underline-offset: 3px;
`;

export const StyledAPContractsTable = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const StyledAPContractsTableRow = styled(Link)`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 14px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
    gap: 12px;

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPContractsTableRowLeft = styled.div<{
    $isExpired: boolean;
}>`
    position: relative;
    max-width: 202px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    &::before {
        display: ${(props) => (props.$isExpired ? "block" : "none")};
        content: "";
        position: absolute;
        top: 0;
        left: -8px;
        width: 5px;
        height: 100%;
        background-color: #f16a1b;
    }
`;

export const StyledAPShelvesHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const StyledAPRacksContainer = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledAPRack = styled.div`
    padding: 20px 16px;
    border-radius: 10px;
    background-color: ${(props) => props.theme.secondaryBackgroundColor};
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledAPShelvesField = styled.div<{
    width: string;
}>`
    width: ${(props) => props.width};
    padding: 12px;
    border-radius: 6px;
    background-color: ${(props) => props.theme.tabsAPBackground};
    border: 1px solid ${(props) => props.theme.secondaryBorderColor};
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: ${(props) => props.theme.shelfValueColor};
`;

export const StyledAPShelvesWrapper = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledAPShelf = styled.div`
    display: flex;
    gap: 8px;
`;

export const StyledAPmmlTable = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledAPmmlTableRow = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
    gap: 8px;

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPmmlProductName = styled(PrimaryText)<{
    isZeroMML: boolean;
}>`
    position: relative;
    font-size: 14px;
    line-height: 120%;
    font-weight: 400;
    max-width: 70%;

    &::before {
        display: ${(props) => (props.isZeroMML ? "block" : "none")};
        content: "";
        position: absolute;
        top: 0;
        left: -8px;
        width: 5px;
        height: 100%;
        background-color: #f16a1b;
    }
`;

export const StyledAPmmlProductPrice = styled(PrimaryText)`
    font-size: 16px;
    line-height: 100%;
    font-weight: 500;
    text-align: right;
    text-wrap: nowrap;

    color: ${(props) => props.theme.additionalTypographyColor} !important;
`;

export const StyledAPContractTable = styled.div`
    width: 100%;
    padding: 16px;
    background: ${(props) => props.theme.secondaryBackgroundColor};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledAPContractTableRow = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;

    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
    gap: 8px;

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPContractTableSplittedRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
`;

export const StyledAPContractTableSplittedBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 50%;
`;

export const StyledAPContractTableFile = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledAPContractTableFileIcon = styled(PaperClipOutlined)`
    font-size: 20px;
    color: ${(props) => props.theme.shelfValueColor};
`;

export const StyledAPContractTableFileName = styled.h4`
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: ${(props) => props.theme.additionalTypographyColor};
    width: fit-content;
`;

export const StyledAPContractTableProductWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 5px;
`;

export const StyledAPContractTableProductRow = styled.div`
    display: flex;
    align-items: flex-start;
    display: flex;
    gap: 8px;
`;

export const StyledAPContractTableAdditionalKey = styled.h4`
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: ${(props) => props.theme.shelfValueColor};
`;

export const StyledProductBarcode = styled.span`
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: ${(props) => props.theme.secondaryTypographyColor};
    border-bottom: 1px dashed ${(props) => props.theme.secondaryTypographyColor};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    position: relative;
    z-index: 2;
`;

export const StyledDebtContainer = styled.div`
    padding: 16px 12px;
    width: 100%;
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledAPPlanContainer = styled.div`
    margin-top: 16px;
    padding: 16px;
    width: 100%;
    background: ${({ theme }) => theme.collapseHeaderBackground};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 80dvh;
    overflow-y: auto;
`;

export const StyledAPPlanItemContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPPlanValue = styled(PrimaryText)<{ $isCompleted: boolean }>`
    color: ${(props) =>
        props.$isCompleted
            ? props.theme.successTypographyColor
            : props.theme.primaryTypographyColor} !important;
`;
